import { GET_DELIVERYSTATUS_SUCCESS_ACTION} from  "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case GET_DELIVERYSTATUS_SUCCESS_ACTION:
      return {
        ...state,
        deliveryStatus: action.payload.rows,
        deliveryStatusCount: action.payload.count,
      };
    default:
      return {
        ...state,
      };
  }
}
